import React, { useState, useEffect } from 'react';

import './styles.css';

import studentsServices from '../../../../services/academy/studentsServices';
import convertAge from '../../../../functions/convertAge';

import StudentClassCardInfo from './StudentClassCardInfo';
import PopupClassChange from './PopupClassChange';
import { FaUsers } from 'react-icons/fa';
import ActivityIndicator from '../../../../components/ActivityIndicator';

export default function StudentClassCard(props) {
    const [popupClassChangeVisible, setPopupClassChangeVisible] = useState(false);
    const [classInfos, setClassInfos] = useState(null);
    const [presences, setPresences] = useState(null);
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        if (props.studentInfos)
            setClassInfos(props.studentInfos.turma);
    }, [props.studentInfos]);

    useEffect(() => {
        if (props.studentId)
            readStudentPresences();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.studentId, classInfos]);

    async function readStudentPresences() {
        const response = await studentsServices.getStudentPresences(props.studentId);
        setFetching(false);
        if (response.status === 200) {
            setPresences(response.data.presencas);
        } else
            alert("Erro ao ler presenças, tente novamente!");
    }

    return (
        <div className='student-page-card' id='card-class'>
            <div className='student-card-class-header'>
                <h4><b>Turma:</b> {classInfos ? classInfos.nome : "Sem turma"}</h4>
                {
                    props.studentProfileMode || fetching ?
                        [] :
                        <>
                            <button
                                onClick={() => { setPopupClassChangeVisible(true) }}
                            >
                                Mudar turma<FaUsers />
                            </button>
                            <PopupClassChange
                                visibility={popupClassChangeVisible}
                                setVisibility={setPopupClassChangeVisible}
                                classId={classInfos ? classInfos.id : null}
                                studentId={props.studentInfos ? props.studentInfos.id : null}
                                studentGender={props.studentInfos ? props.studentInfos.genero : null}
                                studentAge={props.studentInfos ? convertAge(props.studentInfos.data_nascimento) : null}
                                setClassInfos={setClassInfos}
                            />
                        </>
                }
            </div>
            {
                !fetching ?
                    classInfos ?
                        <div className='student-card-class-infos'>
                            <StudentClassCardInfo tittle='Presenças' data={presences} />
                            <StudentClassCardInfo tittle="Em breve..." soon />
                        </div>
                        : []
                    : <ActivityIndicator />
            }
        </div>
    )
}